import { ThemeProvider } from '@ori-ui/mui';
import { UniversalTokenProvider } from '@ori/auth';
import { parseClientAppConfig } from '@ori/client-app-config';
import { createRoot } from 'react-dom/client';

import { App } from './App';
import { EMOTION_CACHE_KEY } from './constants';
import { ErrorBoundary } from './containers/ErrorBoundary';
import type { ClientAppConfig } from './types/ClientAppConfig';

/**
 * React app renderer that is used when app is used as a standalone app
 */
export async function render(rootElement: HTMLElement) {
  const { config = '' } = rootElement.dataset;
  const clientAppConfig = parseClientAppConfig<ClientAppConfig>(config, ['customerId', 'tenant']);
  const { customerId } = clientAppConfig;

  createRoot(rootElement).render(
    <ErrorBoundary>
      <UniversalTokenProvider
        customerId={customerId}
        initialToken=""
      >
        <ThemeProvider
          enableCacheProvider
          cacheKey={EMOTION_CACHE_KEY}
        >
          <App configuration={clientAppConfig} />
        </ThemeProvider>
      </UniversalTokenProvider>
    </ErrorBoundary>,
  );
}
